import Page from "../Common/Page";
import { http } from "../Common/http";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import {
  CommonMasterData,
  DocumentCheckbox,
  getCommonMasterDocuments,
} from "../Components/DocumentCheckbox";
import { ExaminationSubjectRegisterButton } from "../Components/ExaminationSubjectRegisterButton";
import { Messages } from "../Common/ValidateMessages";
import { AuthContext } from "../Auth/Auth";
import React from "react";
import {
  Form,
  Row,
  Col,
  Button,
  DatePicker,
  Space,
  Table,
  Popconfirm,
  message,
  InputNumber,
  Descriptions,
  Modal,
} from "antd";
import { NavigateFunction, Params } from "react-router-dom";
import withRouterDom from "../Common/WithReactRouterDom";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { QuestionSelecter } from "../Components/QuestionSelecter";
import moment from "moment";
import { RubricSelecter } from "../Components/RubricSelecter";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const { confirm } = Modal;

interface Props {
  navigation: NavigateFunction;
  params: Readonly<Params<string>>;
  location: any;
}
interface ExaminationGetRequestBean {
  examinationId: string;
}
interface ExaminationDeleteRequestBean {
  examinationId: string;
}
interface ResultBean {
  result: string;
}
interface ExaminationBean {
  examinationId: string | undefined;
  universityCode: string | undefined;
  fy: string | undefined;
  judgementUnitId: string | undefined;
  examinationNumType: string | undefined;
  examinationDate: string | undefined;
  updatedByUserId: string | undefined;
  examinationSubjectList: ExaminationSubjectBean[];
  documentIdList: string[];
  entranceExam1Name: string | undefined;
  entranceExam2Name: string | undefined;
  entranceExam3Name: string | undefined;
  facultyName: string | undefined;
  departmentName: string | undefined;
  majorName: string | undefined;
  courceName: string | undefined;
  attachedInformation1Name: string | undefined;
  attachedInformation2Name: string | undefined;
  attachedInformation3Name: string | undefined;
}
interface ExaminationSubjectBean {
  examinationSubjectId: string | undefined;
  universityCode: string;
  examinationId: string | undefined;
  subjectId: string;
  seq: string;
  scoringType: string;
  groupCreationRequiredFlag: string | undefined;
  scoringFlag: string;
  // scoringConfirmFlag: string | undefined;
  scoringAllocationFlag: string | undefined;
  scoringNumOfPeople: string | undefined;
  scoringStartDateTime: string | undefined;
  scoringEndDateTime: string | undefined;
  dispFlag_ExamNumber: string | undefined;
  dispFlag_Name: string | undefined;
  dispFlag_NameKana: string | undefined;
  dispFlag_HighSchool: string | undefined;
  dispFlag_Birthday: string | undefined;
  elapsedMinute: string | undefined;
  elapsedSecond: string | undefined;
  threshold: string | undefined;
  questionId: string | undefined;
  rubricId: string | undefined;
  scoringValueType: string | undefined;
  documentIdList: string[];
  subjectName: string | undefined;
  questionName: string | undefined;
  rubricName: string | undefined;
}

class ExaminationRegister extends React.Component<Props> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;
  private _changeFyOperation = false;

  state = {
    // errorMsg: "",
    showDivId: 1,
    formChanged: false,
    examination: {
      examinationId: undefined,
      universityCode: undefined,
      fy: undefined,
      judgementUnitId: undefined,
      examinationNumType: undefined,
      examinationDate: undefined,
      updatedByUserId: undefined,
      examinationSubjectList: [],
      documentIdList: [],
      entranceExam1Name: undefined,
      entranceExam2Name: undefined,
      entranceExam3Name: undefined,
      facultyName: undefined,
      departmentName: undefined,
      majorName: undefined,
      courceName: undefined,
      attachedInformation1Name: undefined,
      attachedInformation2Name: undefined,
      attachedInformation3Name: undefined,
    },
    subjectIdList: [],
    subjectDocumentMasterList: [],
  };

  constructor(props: Props) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
  }

  componentDidMount = async () => {
    const { params } = this.props;

    const gotDatas = await getCommonMasterDocuments(
      this.context.accessToken,
      "2"
    );
    this.setState({ subjectDocumentMasterList: gotDatas });

    if (params.examinationId !== undefined) {
      // 修正の場合
      try {
        this._page.current?.setState({ isPageLoading: true });
        // this.setState({ errorMsg: "" });

        // backend通信し、ユーザ登録
        const postData: ExaminationGetRequestBean = {
          examinationId: params.examinationId,
        };
        const result = await http<ExaminationBean, ExaminationGetRequestBean>({
          path: "/Examination/get",
          method: "post",
          body: postData,
          accessToken: this.context.accessToken,
        });
        if (result.ok) {
          const subjectIdList: string[] | undefined =
            result.body?.examinationSubjectList.map((examinationSubject) => {
              return examinationSubject.subjectId;
            });
          this.setState({
            examination: result.body!,
            subjectIdList: subjectIdList ? subjectIdList : [],
          });
          this._form.current.setFieldsValue({
            fy: { value: result.body!.fy },
            judgementUnitId: result.body!.judgementUnitId,
            examinationNumType: result.body!.examinationNumType,
            examinationDate: result.body!.examinationDate
              ? moment(result.body!.examinationDate, "YYYY-MM-DD")
              : undefined,
            documentIdList: result.body!.documentIdList,
          });
        } else {
          message.error(Messages["ERR-020"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        console.log(error);
        message.error(Messages["ERR-020"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    }
  };
  backToList = () => {
    if (this.state.formChanged) {
      confirm({
        title: Messages["CON-027"],
        icon: <ExclamationCircleOutlined />,
        onOk: () => {
          this.gotoList();
        },
        onCancel: () => {},
      });
    } else {
      this.gotoList();
    }
  };
  gotoList = () => {
    const { location, navigation } = this.props;
    if (location.state) {
      navigation("/ExaminationList", { state: location.state });
    } else {
      navigation("/ExaminationList");
    }
  };
  onFormChanged = (items) => {
    if (
      items.length === 1 &&
      items[0].name[0] === "judgementUnitId" &&
      items[0].value === ""
    ) {
      return;
    }
    this.setState({
      formChanged: true,
    });
  };
  // 登録画面の選択項目変更
  onChangeSeq = (newValue: any) => {
    const examination = this.state.examination;
    examination.examinationNumType = newValue;
    this.setState({
      examination: examination,
    });
  };
  onChangeExamationDate = (newValue: any) => {
    const examination = this.state.examination;
    examination.examinationDate = newValue.format("YYYY-MM-DD");
    this.setState({
      examination: examination,
    });
  };
  onChangeFy = (newValue: any) => {
    this._changeFyOperation = true;

    this._form.current.setFieldsValue({
      judgementUnitId: undefined,
    });
    const examination = this.state.examination;
    examination.fy = newValue !== undefined ? newValue.value : undefined;
    examination.judgementUnitId = undefined;
    examination.entranceExam1Name = undefined;
    examination.entranceExam2Name = undefined;
    examination.entranceExam3Name = undefined;
    examination.facultyName = undefined;
    examination.departmentName = undefined;
    examination.majorName = undefined;
    examination.courceName = undefined;
    examination.attachedInformation1Name = undefined;
    examination.attachedInformation2Name = undefined;
    examination.attachedInformation3Name = undefined;
    this.setState({
      examination: examination,
    });
  };
  onChangeJudgementUnitId = (newValue: any) => {
    if (this._changeFyOperation === false) {
      return;
    }
    const examination = this.state.examination;
    examination.judgementUnitId =
      newValue !== undefined ? newValue.fyJudgementUnitId : undefined;
    examination.entranceExam1Name =
      newValue !== undefined ? newValue.entranceExam1Name : undefined;
    examination.entranceExam2Name =
      newValue !== undefined ? newValue.entranceExam2Name : undefined;
    examination.entranceExam3Name =
      newValue !== undefined ? newValue.entranceExam3Name : undefined;
    examination.facultyName =
      newValue !== undefined ? newValue.facultyName : undefined;
    examination.departmentName =
      newValue !== undefined ? newValue.departmentName : undefined;
    examination.majorName =
      newValue !== undefined ? newValue.majorName : undefined;
    examination.courceName =
      newValue !== undefined ? newValue.courceName : undefined;
    examination.attachedInformation1Name =
      newValue !== undefined ? newValue.attachedInformation1Name : undefined;
    examination.attachedInformation2Name =
      newValue !== undefined ? newValue.attachedInformation2Name : undefined;
    examination.attachedInformation3Name =
      newValue !== undefined ? newValue.attachedInformation3Name : undefined;
    this.setState({
      examination: examination,
    });
  };
  onChangeRubric = (value: any, index: number) => {
    const examination: ExaminationBean = { ...this.state.examination };
    const examinationSubjectList: ExaminationSubjectBean[] = [
      ...examination.examinationSubjectList,
    ];

    examinationSubjectList[index].rubricId = value.rubricId;
    examinationSubjectList[index].rubricName = value.rubricName;
    examination.examinationSubjectList = examinationSubjectList;
    this.setState({
      examination: examination,
    });
  };
  onChangeQuestion = (value: string, index: number) => {
    const examination: ExaminationBean = { ...this.state.examination };
    const examinationSubjectList: ExaminationSubjectBean[] = [
      ...examination.examinationSubjectList,
    ];

    examinationSubjectList[index].questionId = value;
    examination.examinationSubjectList = examinationSubjectList;
    this.setState({
      examination: examination,
    });
  };
  onChangeExaminationSubject = (targetSubjectId?: string, newData?: any) => {
    const examination: ExaminationBean = { ...this.state.examination };
    const subjectIdList: string[] = [...this.state.subjectIdList];
    const examinationSubjectList: ExaminationSubjectBean[] = [
      ...examination.examinationSubjectList,
    ];

    const targetExamSubjectIndex: number = targetSubjectId
      ? examinationSubjectList.findIndex(
          (examinationSubject) =>
            examinationSubject.subjectId === targetSubjectId
        )
      : -1;
    if (newData !== undefined) {
      // 科目登録
      const examinationSubject: ExaminationSubjectBean = {
        examinationSubjectId:
          targetExamSubjectIndex >= 0
            ? examinationSubjectList[targetExamSubjectIndex]
                .examinationSubjectId
            : undefined,
        universityCode: this.context.user.universityCode,
        examinationId: examination.examinationId,
        seq: newData.seq,
        subjectId: newData.subjectId,
        scoringType: newData.scoringType,
        groupCreationRequiredFlag: newData.groupCreationRequiredFlag,
        elapsedMinute: newData.elapsedMinute,
        elapsedSecond: newData.elapsedSecond,
        scoringFlag: newData.scoringFlag,
        // scoringConfirmFlag: newData.scoringConfirmFlag,
        scoringAllocationFlag: newData.scoringAllocationFlag,
        scoringNumOfPeople: newData.scoringNumOfPeople,
        scoringValueType: newData.scoringValueType,
        threshold: newData.threshold,
        scoringStartDateTime: newData.scoringStartDateTime,
        scoringEndDateTime: newData.scoringEndDateTime,
        dispFlag_ExamNumber: newData.dispFlag_ExamNumber,
        dispFlag_Name: newData.dispFlag_Name,
        dispFlag_NameKana: newData.dispFlag_NameKana,
        dispFlag_HighSchool: newData.dispFlag_HighSchool,
        dispFlag_Birthday: newData.dispFlag_Birthday,
        documentIdList: newData.documentIdList,
        subjectName: newData.subjectName,
        questionId:
          targetExamSubjectIndex >= 0
            ? examinationSubjectList[targetExamSubjectIndex].questionId
            : undefined,
        rubricId:
          targetExamSubjectIndex >= 0
            ? examinationSubjectList[targetExamSubjectIndex].rubricId
            : undefined,
        questionName:
          targetExamSubjectIndex >= 0
            ? examinationSubjectList[targetExamSubjectIndex].questionName
            : undefined,
        rubricName:
          targetExamSubjectIndex >= 0
            ? examinationSubjectList[targetExamSubjectIndex].rubricName
            : undefined,
      };
      if (targetExamSubjectIndex >= 0) {
        examinationSubjectList[targetExamSubjectIndex] = examinationSubject;
        subjectIdList[targetExamSubjectIndex] = examinationSubject.subjectId;
      } else {
        examinationSubjectList.push(examinationSubject);
        subjectIdList.push(examinationSubject.subjectId);
      }
    } else {
      // 科目削除
      if (targetExamSubjectIndex >= 0) {
        examinationSubjectList.splice(targetExamSubjectIndex, 1);
        subjectIdList.splice(targetExamSubjectIndex, 1);
      } else {
        return;
      }
    }

    examination.examinationSubjectList = examinationSubjectList;
    this.setState({
      examination: examination,
      subjectIdList: subjectIdList,
    });
  };

  // 登録・修正ボタン押す
  onRegister = async (values: any) => {
    const examination: ExaminationBean = this.state.examination;
    if (
      examination.examinationSubjectList === null ||
      examination.examinationSubjectList.length === 0
    ) {
      message.error(Messages["ERR-058"]);
      return;
    }
    const intMaxSeq = Number.parseInt(examination.examinationNumType!);
    const seqArray: boolean[] = [];
    for (let i = 1; i <= intMaxSeq; i++) {
      seqArray.push(false);
    }
    let intMaxSubjectSeq = 0;
    for (const examinationSubject of examination.examinationSubjectList) {
      if (intMaxSubjectSeq < Number.parseInt(examinationSubject.seq)) {
        intMaxSubjectSeq = Number.parseInt(examinationSubject.seq);
      }
      seqArray[Number.parseInt(examinationSubject.seq) - 1] = true;
      if (
        examinationSubject.scoringFlag === "1" &&
        (examinationSubject.rubricId === null ||
          examinationSubject.rubricId === undefined)
      ) {
        message.error(Messages["ERR-059"]);
        return;
      }
    }
    if (intMaxSubjectSeq !== intMaxSeq) {
      message.error(Messages["ERR-060"]);
      return;
    }
    for (let i = 1; i <= intMaxSeq; i++) {
      if (!seqArray[i - 1]) {
        message.error(`${i}${Messages["ERR-061"]}`);
        return;
      }
    }

    confirm({
      title: Messages["CON-031"],
      icon: <ExclamationCircleOutlined />,
      onOk: async () => {
        await this.doSave(examination, values);
      },
      onCancel: () => {},
    });
  };

  doSave = async (examination: ExaminationBean, values: any) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      // this.setState({ errorMsg: "" });

      // 大学コード＋入試年度＋判定単位のユニック判断
      const postData: any = {
        examinationId: this.state.examination.examinationId,
        fy: this.state.examination.fy,
        judgementUnitId: this.state.examination.judgementUnitId,
      };
      let result = await http<any, any>({
        path: "/Examination/check/judgementunit",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        // 存在する
        message.error(Messages["ERR-062"]);
        this._page.current?.setState({ isPageLoading: false });
        return;
      }

      // 試験登録
      // examination.universityCode = this.context.user.universityCode;
      examination.examinationDate = values.examinationDate
        ? values.examinationDate.format("YYYY-MM-DD")
        : undefined;
      // examination.updatedByUserId = this.context.user.userId;
      examination.documentIdList = values.documentIdList;
      result = await http<ResultBean, ExaminationBean>({
        path: "/Examination/save",
        method: "post",
        body: examination,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        // 保存成功
        this.setState({ showDivId: 2 });
      } else {
        // 失敗
        message.error(Messages["ERR-020"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      // エラー
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 削除ボタン押す
  onDelete = async () => {
    if (this.state.examination.examinationId !== undefined) {
      try {
        this._page.current?.setState({ isPageLoading: true });
        // backend通信し、ユーザ登録
        const postData: ExaminationDeleteRequestBean = {
          examinationId: this.state.examination.examinationId,
        };
        const result = await http<ResultBean, ExaminationDeleteRequestBean>({
          path: "/Examination/delete",
          method: "post",
          body: postData,
          accessToken: this.context.accessToken,
        });
        if (result.ok) {
          if (result.body?.result === "1") {
            // 削除成功
            // 完了画面表示
            this.setState({ showDivId: 2 });
            this.setState({
              examination: {
                examinationId: undefined,
                universityCode: undefined,
                fy: undefined,
                judgementUnitId: undefined,
                examinationNumType: undefined,
                examinationDate: undefined,
                updatedByUserId: undefined,
                examinationSubjectList: [],
                documentIdList: [],
                entranceExam1Name: undefined,
                entranceExam2Name: undefined,
                entranceExam3Name: undefined,
                facultyName: undefined,
                departmentName: undefined,
                majorName: undefined,
                courceName: undefined,
                attachedInformation1Name: undefined,
                attachedInformation2Name: undefined,
                attachedInformation3Name: undefined,
              },
              subjectIdList: [],
            });
          } else if (result.body?.result === "2") {
            message.error(Messages["ERR-088"]);
          } else if (result.body?.result === "3") {
            message.error(Messages["ERR-089"]);
          } else {
            message.error(Messages["ERR-020"]);
          }
        } else {
          message.error(Messages["ERR-020"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        console.log(error);
        message.error(Messages["ERR-020"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    }
  };

  columns = [
    {
      title: <div className="table-title">編集</div>,
      key: "action",
      render: (text: any, record: any) => (
        <Space size="middle" direction="vertical">
          <ExaminationSubjectRegisterButton
            label="編集"
            fy={this.state.examination.fy}
            maxSeq={this.state.examination.examinationNumType}
            examinationDate={this.state.examination.examinationDate}
            subjectIdList={this.state.subjectIdList}
            targetSubject={record}
            width={45}
            onChange={this.onChangeExaminationSubject}
          />
        </Space>
      ),
      width: 55,
    },
    {
      title: <div className="table-title">n次</div>,
      dataIndex: "seq",
      key: "seq",
      width: 30,
    },
    {
      title: <div className="table-title">試験科目</div>,
      dataIndex: "subjectName",
      key: "subjectName",
      width: 120,
    },
    {
      title: <div className="table-title">ルーブリック</div>,
      key: "action",
      render: (text: any, record: any, index: number) =>
        record.scoringFlag === "1" ? (
          <Space size="middle" direction="vertical">
            <RubricSelecter
              groupCreationRequiredFlag={record.groupCreationRequiredFlag}
              scoringType={record.scoringType}
              width={130}
              label={record.rubricName}
              onChange={(value: string) => this.onChangeRubric(value, index)}
            />
          </Space>
        ) : (
          "-"
        ),
      width: 155,
    },
    {
      title: <div className="table-title">問題</div>,
      key: "action",
      render: (text: any, record: any, index: number) =>
        record.scoringFlag === "1" && record.scoringType === "1" ? (
          <Space size="middle" direction="vertical">
            <QuestionSelecter
              width={130}
              value={record.questionId}
              onChange={(value: string) => this.onChangeQuestion(value, index)}
            />
          </Space>
        ) : (
          "-"
        ),
      width: 155,
    },
    {
      title: <div className="table-title">試験科目提出書類</div>,
      dataIndex: "scoringFlag",
      render: (text: any, record: any) => {
        if (
          this.state.subjectDocumentMasterList.length > 0 &&
          record.documentIdList != null &&
          record.documentIdList.length > 0
        ) {
          const documents: string[] = [];
          this.state.subjectDocumentMasterList.forEach(
            (element: CommonMasterData) => {
              if (record.documentIdList.indexOf(element.id) >= 0) {
                documents.push(element.name);
              }
            }
          );
          return <span>{documents.join(",")}</span>;
        }
      },
      width: 120,
    },
    {
      title: <div className="table-title">採点</div>,
      dataIndex: "scoringFlag",
      render: (text: any, record: any) => (
        <span>{record.scoringFlag === "1" ? "採点対象" : "対象外"}</span>
      ),
      width: 60,
    },
    {
      title: <div className="table-title">種別</div>,
      dataIndex: "scoringType",
      render: (text: any, record: any) => (
        <span>
          {record.scoringFlag === "1"
            ? record.scoringType === "1"
              ? "答案"
              : "面接"
            : ""}
        </span>
      ),
      width: 40,
    },
    {
      title: <div className="table-title">採点開始日時</div>,
      dataIndex: "scoringStartDateTime",
      width: 100,
    },
    {
      title: <div className="table-title">採点終了日時</div>,
      dataIndex: "scoringEndDateTime",
      width: 100,
    },
    {
      title: <div className="table-title">採点確定値種別</div>,
      dataIndex: "scoringValueType",
      width: 70,
      render: (text: any, record: any) => (
        <span>
          {record.scoringFlag === "1"
            ? record.scoringValueType === "1"
              ? "合計点"
              : "平均点"
            : ""}
        </span>
      ),
    },
    // {
    //   title: <div className="table-title">採点確定処理</div>,
    //   dataIndex: "scoringConfirmFlag",
    //   width: 60,
    //   render: (text: any, record: any) => (
    //     <span>
    //       {record.scoringFlag === "1"
    //         ? record.scoringConfirmFlag === "1"
    //           ? "行う"
    //           : "行わない"
    //         : ""}
    //     </span>
    //   ),
    // },
    {
      title: <div className="table-title">採点割り振り</div>,
      dataIndex: "scoringAllocationFlag",
      width: 60,
      render: (text: any, record: any) => (
        <span>
          {record.scoringFlag === "1"
            ? record.scoringAllocationFlag === "1"
              ? "行う"
              : "行わない"
            : ""}
        </span>
      ),
    },
    {
      title: <div className="table-title">採点人数</div>,
      dataIndex: "scoringNumOfPeople",
      width: 60,
      render: (text: any, record: any) => (
        <span>
          {record.scoringFlag === "1" && record.scoringNumOfPeople
            ? record.scoringNumOfPeople
            : ""}
        </span>
      ),
    },
    {
      title: <div className="table-title">採点時アラート</div>,
      dataIndex: "threshold",
      width: 70,
      render: (text: any, record: any) => (
        <span>
          {record.scoringFlag === "1" && record.threshold
            ? record.threshold
            : ""}
        </span>
      ),
    },
  ];

  render(): React.ReactNode {
    return (
      <Page title="試験登録/修正" ref={this._page}>
        <div
          style={{
            margin: "0px 20px 0px 20px ",
            display: this.state.showDivId === 1 ? "block" : "none",
          }}
        >
          <div style={{ margin: "10px 20px 0px 20px " }}>
            <Form
              name="examinationEdit"
              layout="horizontal"
              labelCol={{ span: 8 }}
              colon={false}
              labelAlign="left"
              labelWrap={true}
              onFieldsChange={this.onFormChanged}
              onFinish={this.onRegister}
              className="user-form"
              ref={this._form}
            >
              <Row>
                <Col span={6}>
                  <Form.Item
                    label="入試年度"
                    name="fy"
                    rules={[{ required: true }]}
                  >
                    <CommonMasterSelect
                      masterType={31}
                      allowClear={false}
                      width={100}
                      onChange={this.onChangeFy}
                    />
                  </Form.Item>
                </Col>
                <Col offset={14} span={4}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.backToList}
                  >
                    試験一覧に戻る
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="判定単位"
                    name="judgementUnitId"
                    labelCol={{ span: 2 }}
                    rules={[
                      { required: true, validateTrigger: ["onBlur"] },
                      {
                        validator: () => {
                          if (this.state.examination.fy === "") {
                            return Promise.reject(
                              new Error("入試年度" + Messages["ERR-055"])
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <JudgmentUnitSelecter
                      width={500}
                      defaultFy={this.state.examination.fy}
                      onDataSelect={this.onChangeJudgementUnitId}
                      allSearch={true}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ background: "#FFFFFF" }}>
                <Col span={24}>
                  <Descriptions
                    bordered
                    size="small"
                    column={4}
                    contentStyle={{ minWidth: "60px" }}
                  >
                    <Descriptions.Item label="入試制度1">
                      {this.state.examination.entranceExam1Name}
                    </Descriptions.Item>
                    <Descriptions.Item label="入試制度2">
                      {this.state.examination.entranceExam2Name}
                    </Descriptions.Item>
                    <Descriptions.Item label="入試制度3" span={2}>
                      {this.state.examination.entranceExam3Name}
                    </Descriptions.Item>
                    <Descriptions.Item label="学部">
                      {this.state.examination.facultyName}
                    </Descriptions.Item>
                    <Descriptions.Item label="学科">
                      {this.state.examination.departmentName}
                    </Descriptions.Item>
                    <Descriptions.Item label="専攻">
                      {this.state.examination.majorName}
                    </Descriptions.Item>
                    <Descriptions.Item label="コース">
                      {this.state.examination.courceName}
                    </Descriptions.Item>
                    <Descriptions.Item label="付属情報1">
                      {this.state.examination.attachedInformation1Name}
                    </Descriptions.Item>
                    <Descriptions.Item label="付属情報2">
                      {this.state.examination.attachedInformation2Name}
                    </Descriptions.Item>
                    <Descriptions.Item label="付属情報3" span={2}>
                      {this.state.examination.attachedInformation3Name}
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Row>

              <Row style={{ marginTop: "10px" }}>
                <Col span={6}>
                  <Form.Item
                    label="N次"
                    name="examinationNumType"
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      min={1}
                      max={5}
                      style={{ width: "50px" }}
                      onChange={this.onChangeSeq}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item
                    label="試験日"
                    name="examinationDate"
                    rules={[{ required: true }]}
                  >
                    <DatePicker onChange={this.onChangeExamationDate} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="共通書類"
                    name="documentIdList"
                    labelCol={{ span: 2 }}
                  >
                    <DocumentCheckbox fid={"1"} width={800} />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <ExaminationSubjectRegisterButton
                  label="試験科目登録"
                  fy={this.state.examination.fy}
                  maxSeq={this.state.examination.examinationNumType}
                  examinationDate={this.state.examination.examinationDate}
                  width={200}
                  subjectIdList={this.state.subjectIdList}
                  onChange={this.onChangeExaminationSubject}
                />
                {/* <ExaminationSubjectRegisterButton
                  label="2次試験科目登録"
                  fy={this.state.examination.fy}
                  seq={2}
                  width={200}
                  subjectIdList={this.state.subjectIdList}
                  onChange={this.onChangeExaminationSubject}
                /> */}
              </Row>

              <Table
                rowKey={(record: any) => record.subjectId}
                bordered
                columns={this.columns}
                dataSource={this.state.examination.examinationSubjectList}
                scroll={{ x: 1300, y: 800 }}
                pagination={false}
              />

              <Row style={{ marginTop: "10px", marginLeft: "10px" }}>
                <Col span={4} offset={14}>
                  {this.state.examination.examinationId !== undefined && (
                    <Popconfirm
                      title={Messages["CON-001"]}
                      okText="はい"
                      cancelText="いいえ"
                      onConfirm={this.onDelete}
                    >
                      <Button type="primary" htmlType="button">
                        削除
                      </Button>
                    </Popconfirm>
                  )}
                </Col>
                <Col span={4}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      登録/修正
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
        <div
          style={{
            margin: "20px",
            display: this.state.showDivId === 2 ? "block" : "none",
          }}
        >
          <div>試験登録・修正は完了しました。</div>
          <div style={{ margin: "20px" }}>
            <Row style={{ marginTop: "10px", marginLeft: "10px" }}>
              <Col span={5}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => {
                    const { navigation } = this.props;
                    navigation("/ExaminationList");
                  }}
                >
                  試験一覧へ
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Page>
    );
  }
}

export default withRouterDom(ExaminationRegister);
